module.exports.schemaString = "";
module.exports.AlertSort = {
  ALPHABETICAL: "ALPHABETICAL", CREATED: "CREATED", STATUS: "STATUS"
};
module.exports.ApiTokenSort = {
  ACTIVE: "ACTIVE", ALPHABETICAL: "ALPHABETICAL", CREATED: "CREATED", ENVIRONMENT: "ENVIRONMENT", ROLE: "ROLE"
};
module.exports.ApmHostSort = {
  ALPHABETICAL: "ALPHABETICAL", ERROR_RATE: "ERROR_RATE", REQUESTS: "REQUESTS", RESPONSE_TIME: "RESPONSE_TIME"
};
module.exports.ApmHttpMethodSort = {
  ERROR_RATE: "ERROR_RATE", NAME: "NAME", REQUESTS: "REQUESTS", RESPONSE_TIME: "RESPONSE_TIME"
};
module.exports.ApmHttpStatusSort = {
  CODE: "CODE", ERROR_RATE: "ERROR_RATE", REQUESTS: "REQUESTS", RESPONSE_TIME: "RESPONSE_TIME"
};
module.exports.ApmServiceSort = {
  ALPHABETICAL: "ALPHABETICAL", ERROR_RATE: "ERROR_RATE", HOST_COUNT: "HOST_COUNT", REQUESTS: "REQUESTS", RESPONSE_TIME: "RESPONSE_TIME"
};
module.exports.ApmTracedOutboundCallsSortEnum = {
  DURATION: "DURATION", TIME: "TIME"
};
module.exports.ApmTracedRequestsSortEnum = {
  HTTP_STATUS: "HTTP_STATUS", RESPONSE_TIME: "RESPONSE_TIME", TIME: "TIME"
};
module.exports.ApmTransactionSort = {
  ALPHABETICAL: "ALPHABETICAL", ERROR_RATE: "ERROR_RATE", REQUESTS: "REQUESTS", RESPONSE_TIME: "RESPONSE_TIME"
};
module.exports.CacheCallSort = {
  ALPHABETICAL: "ALPHABETICAL", AVERAGE_RESPONSE_TIME: "AVERAGE_RESPONSE_TIME", FREQUENCY: "FREQUENCY", HIT_RATE: "HIT_RATE", TOTAL_TIME: "TOTAL_TIME"
};
module.exports.ContainerSortEnum = {
  ALPHABETICAL: "ALPHABETICAL"
};
module.exports.DashboardSort = {
  ALPHABETICAL: "ALPHABETICAL", CREATED: "CREATED"
};
module.exports.DatabaseQuerySort = {
  ALPHABETICAL: "ALPHABETICAL", AVERAGE_RESPONSE_TIME: "AVERAGE_RESPONSE_TIME", FREQUENCY: "FREQUENCY", TOTAL_TIME: "TOTAL_TIME"
};
module.exports.DurationUnit = {
  Days: "Days", Hours: "Hours", Minutes: "Minutes", Seconds: "Seconds", Weeks: "Weeks"
};
module.exports.ExceptionGroupSortEnum = {
  EXCEPTION_CLASS: "EXCEPTION_CLASS", EXCEPTION_MESSAGE: "EXCEPTION_MESSAGE", FIRST_OCCURRED: "FIRST_OCCURRED", FREQUENCY: "FREQUENCY", LAST_OCCURRED: "LAST_OCCURRED"
};
module.exports.GlobalSearchEntity = {
  ALERT: "ALERT", ALL: "ALL", DASHBOARD: "DASHBOARD", HOST: "HOST", METRIC: "METRIC", SERVICE: "SERVICE"
};
module.exports.HostAgentPluginSort = {
  ALPHABETICAL: "ALPHABETICAL", ENABLED: "ENABLED"
};
module.exports.HostAgentPluginTypeEnum = {
  ALL: "ALL", AVAILABLE: "AVAILABLE", ENABLED: "ENABLED"
};
module.exports.HostedServiceEnum = {
  AWS: "AWS", HEROKU: "HEROKU", LOGGLY: "LOGGLY", PAPERTRAIL: "PAPERTRAIL"
};
module.exports.InfrastructureHostSort = {
  ALPHABETICAL: "ALPHABETICAL", CREATED: "CREATED"
};
module.exports.InfrastructureHostType = {
  APM: "APM", INFRASTRUCTURE: "INFRASTRUCTURE", SLINGBOT: "SLINGBOT", SNAP: "SNAP", UNKNOWN: "UNKNOWN"
};
module.exports.InfrastructureHostViewOrderBy = {
  CPU_UTILIZATION: "CPU_UTILIZATION", DISK_IO: "DISK_IO", FILL: "FILL", HOST_NAME: "HOST_NAME", MEMORY_UTILIZATION: "MEMORY_UTILIZATION", NETWORK_IO: "NETWORK_IO"
};
module.exports.InfrastructureHostViewType = {
  LIST: "LIST", MAP: "MAP"
};
module.exports.InfrastructureHostViewTypeEnum = {
  CONTAINER: "CONTAINER", HOST: "HOST"
};
module.exports.InvoiceSort = {
  DATE: "DATE", ID: "ID", TOTAL: "TOTAL"
};
module.exports.KpiChartStreamFields = {
  COUNT: "COUNT", LAST: "LAST", MAX: "MAX", MIN: "MIN", TIMESTAMP: "TIMESTAMP", VALUE: "VALUE"
};
module.exports.KpiName = {
  CLOUDWATCH_CPU: "CLOUDWATCH_CPU", CLOUDWATCH_DISK_IO: "CLOUDWATCH_DISK_IO", CLOUDWATCH_MEMORY: "CLOUDWATCH_MEMORY", CLOUDWATCH_NETWORK_IO: "CLOUDWATCH_NETWORK_IO", CONTAINER_CPU: "CONTAINER_CPU", CONTAINER_DISK_IO: "CONTAINER_DISK_IO", CONTAINER_MEMORY: "CONTAINER_MEMORY", CONTAINER_MEMORY_RSS: "CONTAINER_MEMORY_RSS", CONTAINER_NETWORK_IO: "CONTAINER_NETWORK_IO", HOST_CPU: "HOST_CPU", HOST_DISK_IO: "HOST_DISK_IO", HOST_MEMORY: "HOST_MEMORY", HOST_NETWORK_IO: "HOST_NETWORK_IO", SERVICE_ERROR_RATE: "SERVICE_ERROR_RATE", SERVICE_HOST_CPU: "SERVICE_HOST_CPU", SERVICE_REQUESTS: "SERVICE_REQUESTS", SERVICE_RESPONSE_TIME: "SERVICE_RESPONSE_TIME"
};
module.exports.MetricsReportSort = {
  AVERAGE: "AVERAGE", MAX: "MAX", METRIC: "METRIC"
};
module.exports.NotificationServiceSort = {
  TITLE: "TITLE", TYPE: "TYPE"
};
module.exports.OrganizationBillingAccountTypeEnum = {
  ANNUAL: "ANNUAL", MONTHLY: "MONTHLY"
};
module.exports.RemoteServiceSort = {
  ALPHABETICAL: "ALPHABETICAL", AVERAGE_RESPONSE_TIME: "AVERAGE_RESPONSE_TIME", FREQUENCY: "FREQUENCY", TOTAL_TIME: "TOTAL_TIME"
};
module.exports.ResourceChangeLogEnum = {
  CREATE: "CREATE", DELETE: "DELETE", UPDATE: "UPDATE"
};
module.exports.ServiceMapTagValuesEnum = {
  SERVICE: "SERVICE", TRACE_TRANSACTION: "TRACE_TRANSACTION"
};
module.exports.SortDirection = {
  ASC: "ASC", DESC: "DESC"
};
module.exports.TracedExceptionSortEnum = {
  EXCEPTION_CLASS: "EXCEPTION_CLASS", EXCEPTION_MESSAGE: "EXCEPTION_MESSAGE", HTTP_METHOD: "HTTP_METHOD", HTTP_STATUS: "HTTP_STATUS", SERVICE_DURATION: "SERVICE_DURATION", TIME: "TIME", TRANSACTION: "TRANSACTION"
};
module.exports.UsageReportSort = {
  CONTAINER: "CONTAINER", CUSTOM_METRICS: "CUSTOM_METRICS", ENTERPRISE: "ENTERPRISE", PRO: "PRO", TIMESTAMP: "TIMESTAMP"
};